import React, { Fragment, useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import "../../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../../assets/css/PrimeGrid.css";

import { saveAs } from "file-saver";

import { AlertContext } from "../../../../context/AlertContext";
import { AuthContext } from "../../../../context/AuthContext";
import { ServiciosContext } from "../../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import { getBrand, createBrandTheme } from "../../../../theme/brand";
import Spinner from "../../Spinner";
import Barra from "../../Barra";

const tipos = [
  { nombre: "Mensual", id: "1" },
  { nombre: "Anual", id: "2" },
];

const exportColumns = [
  { title: "Titular", dataKey: "titularId" },
  { title: "Tope", dataKey: "cantidad" },
  { title: "Habilitado", dataKey: "habilitado" },
];

export default function Topes() {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tope, guardarTope] = useState(null);
  const [visible, setVisible] = useState(false);
  const [titularId, setTitularId] = useState(null);
  const [titularNombre, setTitularNombre] = useState(null);
  const [titularSeleccionado, setTitularSeleccionado] = useState(null);
  const toast = useRef(null);
  const navigate = useNavigate();

  const { mensajeAlerta } = useContext(AlertContext);
  const { state } = useContext(AuthContext);
  const { rows, setRows, obtenerDatosTitulares } = useContext(ServiciosContext);
  const {
    statusAcceso,
    topes,
    colores,
    configuracion,
    obtenerTopes,
    obtenerAcceso,
    agregarTope,
    actualizarTope,
    obtenerColores,
  } = useContext(ConfiguracionContext);

  const theme = createBrandTheme(getBrand(configuracion));
  const enMovil = useMediaQuery("(max-width:600px)");
  const esDest4 = configuracion && configuracion.destinatario === 4;
  const editando = Boolean(selectedRow);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Topes" });
    }
    obtenerTopes({ todos: true });
    obtenerColores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (statusAcceso === 400) {
      mensajeAlerta(
        "Accesos",
        "No tiene permiso para acceder a esta pantalla !.",
        "error"
      );
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusAcceso]);

  const editClick = () => {
    if (!selectedRow) {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un tope.",
        life: 3000,
      });
      return;
    }
    guardarTope(selectedRow);
    setTitularId(selectedRow.titularId);
    setTitularNombre(selectedRow.nombre);
    setTitularSeleccionado(selectedRow);
    setRows(selectedRow);
    setVisible(true);
  };

  const addClick = () => {
    setTitularId(null);
    setTitularNombre(null);
    setTitularSeleccionado(null);
    setSelectedRow(null);
    guardarTope({ habilitado: true });
    setVisible(true);
  };

  const buscarAfiliados = () => {
    if (titularNombre) {
      obtenerDatosTitulares({ opcion: "Apellido y nombre", texto: titularNombre });
    }
    if (titularId) {
      obtenerDatosTitulares({ opcion: "Número de socio", texto: titularId });
    }
  };

  const onHide = () => {
    setVisible(false);
    setRows(null);
  };

  const aceptarClick = () => {
    if (!titularId || String(titularId).trim() === "") {
      mensajeAlerta("Topes de Servicios", "El titular es necesario !.", "error");
      return;
    }
    if (!titularSeleccionado) {
      mensajeAlerta("Topes de Servicios", "El titular es necesario !.", "error");
      return;
    }
    if (esDest4 && (!tope || !tope.colorId)) {
      mensajeAlerta("Topes de Servicios", "El color es necesario !.", "error");
      return;
    }
    if (!tope || !tope.cantidad) {
      mensajeAlerta("Topes de Servicios", "El tope es necesario !.", "error");
      return;
    }
    if (!tope || !tope.tipo) {
      mensajeAlerta("Topes de Servicios", "La frecuencia es necesaria !.", "error");
      return;
    }

    if (selectedRow) {
      actualizarTope({ tope });
    } else {
      agregarTope({ tope, titularSeleccionado });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => obtenerTopes({ todos: true }), 2000);
  };

  const exitClick = () => navigate("/");

  const colorTemplate = (row) => (row.colores ? row.colores.nombre : "");
  const habilitadoTemplate = (row) => (
    <Chip
      size="small"
      label={row.habilitado ? "Sí" : "No"}
      color={row.habilitado ? "success" : "default"}
      variant={row.habilitado ? "filled" : "outlined"}
    />
  );

  const exportPdf = () => {
    import("jspdf").then((jsPDFmod) => {
      import("jspdf-autotable").then(() => {
        const JsPDF = jsPDFmod.jsPDF || jsPDFmod.default;
        const doc = new JsPDF();
        doc.setFontSize(12);
        doc.text("Listado de Topes de Servicios", 14, 10);
        doc.autoTable({
          head: [exportColumns.map((c) => c.title)],
          body: (topes || []).map((r) =>
            exportColumns.map((c) =>
              c.dataKey === "habilitado"
                ? r.habilitado
                  ? "Sí"
                  : "No"
                : r[c.dataKey]
            )
          ),
          startY: 16,
          styles: { overflow: "linebreak" },
        });
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(topes || []);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(blob, `topes_export_${new Date().getTime()}.xlsx`);
    });
  };

  const cargando = statusAcceso === 0 || statusAcceso === 400;

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />

      {cargando ? <Spinner /> : null}

      {statusAcceso === 200 ? (
        <ThemeProvider theme={theme}>
          <Box id="dataTableBotones" sx={{ px: { xs: 1, sm: 2 }, pb: 3 }}>
            {topes ? (
              <Fragment>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    alignItems={{ xs: "stretch", md: "center" }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexShrink: 0 }}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: 2,
                          display: "grid",
                          placeItems: "center",
                          bgcolor: "primary.main",
                          color: "primary.contrastText",
                        }}
                      >
                        <SpeedOutlinedIcon />
                      </Box>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                          Topes de Servicios
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {`${topes.length} registros`}
                        </Typography>
                      </Box>
                    </Stack>

                    <Box sx={{ flexGrow: 1 }} />

                    <TextField
                      size="small"
                      placeholder="Buscar…"
                      onInput={(e) => setGlobalFilter(e.target.value)}
                      sx={{ minWidth: { xs: "100%", md: 240 } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>

                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 2 }}>
                    <Button variant="contained" startIcon={<AddIcon />} onClick={addClick}>
                      Nuevo
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<EditOutlinedIcon />}
                      onClick={editClick}
                      disabled={!selectedRow}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="outlined"
                      color="success"
                      startIcon={<FileDownloadOutlinedIcon />}
                      onClick={exportExcel}
                    >
                      Excel
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<PictureAsPdfOutlinedIcon />}
                      onClick={exportPdf}
                    >
                      PDF
                    </Button>
                    <Box sx={{ flexGrow: 1 }} />
                    <Button
                      variant="text"
                      color="inherit"
                      startIcon={<CloseIcon />}
                      onClick={exitClick}
                    >
                      Cerrar
                    </Button>
                  </Stack>
                </Paper>

                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    overflow: "hidden",
                    "& .p-datatable-wrapper": { overflowX: "auto" },
                    "& .p-datatable-thead > tr > th, & .p-datatable-tbody > tr > td": {
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <DataTable
                    value={topes}
                    selection={selectedRow}
                    onSelectionChange={(e) => setSelectedRow(e.value)}
                    selectionMode="single"
                    dataKey="id"
                    className="p-datatable-sm p-datatable-striped p-datatable-responsive-demo mito-grid"
                    globalFilter={globalFilter}
                    emptyMessage="No hay datos."
                    paginator
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                  >
                    <Column field="titularId" header="Titular" sortable />
                    <Column field="nombre" header="Nombre" sortable />
                    {esDest4 ? (
                      <Column field="color" header="Color" body={colorTemplate} sortable />
                    ) : null}
                    <Column field="cantidad" header="Tope" sortable />
                    <Column field="tipo" header="Frecuencia" sortable />
                    <Column field="habilitado" header="Habilitado" body={habilitadoTemplate} sortable />
                  </DataTable>
                </Paper>
              </Fragment>
            ) : (
              <Spinner />
            )}
          </Box>

          <Dialog
            open={visible}
            onClose={onHide}
            maxWidth="lg"
            fullWidth
            fullScreen={enMovil}
          >
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 700 }}>
              <SpeedOutlinedIcon color="primary" />
              {editando ? "Editar tope de servicio" : "Nuevo tope de servicio"}
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2} sx={{ mt: 0 }} alignItems="flex-end">
                <Grid item xs={12} md={2}>
                  <TextField
                    label="ID Titular"
                    type="number"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={titularId || ""}
                    disabled={Boolean(titularNombre) || editando}
                    onChange={(e) => {
                      setTitularId(e.target.value);
                      setTitularSeleccionado(null);
                      setRows(null);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Apellido y Nombre o Razón Social"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={titularNombre || ""}
                    disabled={Boolean(titularId) || editando}
                    onChange={(e) => {
                      setTitularNombre(e.target.value);
                      setTitularSeleccionado(null);
                      setRows(null);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={1}>
                  <IconButton color="primary" onClick={buscarAfiliados} disabled={editando}>
                    <SearchIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={12} md={5}>
                  <Autocomplete
                    options={rows || []}
                    disabled={!rows || editando}
                    noOptionsText="No hay opciones"
                    value={!rows || editando ? null : titularSeleccionado}
                    disablePortal
                    getOptionLabel={(o) => (o && o.nombre_razonsocial) || ""}
                    onChange={(e, value) => {
                      if (value) {
                        setTitularSeleccionado(value);
                        setTitularId(value.id_titular);
                        setTitularNombre(null);
                      } else {
                        setTitularSeleccionado(null);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Seleccione el Afiliado" size="small" />
                    )}
                  />
                </Grid>

                {esDest4 ? (
                  <Grid item xs={12} md={5}>
                    <Autocomplete
                      options={colores || []}
                      disabled={!rows || editando}
                      disablePortal
                      value={
                        tope && tope.colorId != null && colores
                          ? colores.find((c) => c.id === tope.colorId) || null
                          : null
                      }
                      getOptionLabel={(o) => (o && o.nombre) || ""}
                      onChange={(e, value) => {
                        if (value) {
                          const data = (topes || []).find(
                            (o) => o.titularId === titularId && o.colorId === value.id
                          );
                          guardarTope({
                            ...tope,
                            colorId: value.id,
                            cantidad: data ? data.cantidad : 0,
                          });
                        } else {
                          guardarTope({ ...tope, colorId: null, cantidad: null });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Colores" size="small" />
                      )}
                    />
                  </Grid>
                ) : null}

                <Grid item xs={12} md={2}>
                  <TextField
                    label="Tope"
                    type="number"
                    required
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={tope && tope.cantidad != null ? tope.cantidad : ""}
                    onChange={(e) => guardarTope({ ...tope, cantidad: e.target.value })}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={tipos}
                    disablePortal
                    value={
                      tope && tope.tipo
                        ? tipos.find((t) => t.nombre === tope.tipo) || null
                        : null
                    }
                    getOptionLabel={(o) => (o && o.nombre) || ""}
                    onChange={(e, value) =>
                      guardarTope({
                        ...tope,
                        tipoId: value ? value.id : null,
                        tipo: value ? value.nombre : null,
                      })
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Frecuencia" size="small" />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={tope ? !!tope.habilitado : false}
                        onChange={(e) =>
                          guardarTope({ ...tope, habilitado: e.target.checked })
                        }
                      />
                    }
                    label="Habilitado"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
              <Button onClick={onHide} color="inherit" startIcon={<CloseIcon />}>
                Cancelar
              </Button>
              <Button onClick={aceptarClick} variant="contained" startIcon={<CheckIcon />}>
                Guardar
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      ) : null}
    </Fragment>
  );
}
